/** Called when API returns 403 with code ACCOUNT_BANNED so AuthContext can refresh /me. */
let bannedSyncHandler: (() => void) | null = null;

export function registerBannedSyncHandler(handler: (() => void) | null): void {
  bannedSyncHandler = handler;
}

export function notifyBannedFromApi(): void {
  bannedSyncHandler?.();
}
